// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-AutoDocExtraction-Sparkle-Sparkle-module__right";
var _2 = "webpack-concepts-AutoDocExtraction-Sparkle-Sparkle-module__sparkle";
var _3 = "webpack-concepts-AutoDocExtraction-Sparkle-Sparkle-module__tooltipMessage";
var _4 = "webpack-concepts-AutoDocExtraction-Sparkle-Sparkle-module__wrapper";
export { _1 as "right", _2 as "sparkle", _3 as "tooltipMessage", _4 as "wrapper" }
